import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { postDocumentsNotes } from '../requests';
import type {
  PostDocumentNotesRequestType,
  PostDocumentNotesResponseType,
} from '../types';

export const usePostDocumentNotes = (
  documentId?: PostDocumentNotesRequestType['documentId'],
) => {
  const queryClient = useQueryClient();
  const { refetchAllDocumentsQueries } = useDocumentCache();

  /**
   * Handles the success response of the mutation.
   *
   * @param data - The response data from the mutation.
   * @param payload - The payload of the mutation.
   */
  const onSuccess = async (
    _data: PostDocumentNotesResponseType,
    payload: string | null,
  ) => {
    queryClient.setQueryData(
      [API_QUERY_KEYS.document, { documentId }],
      (oldData: any) => ({
        ...oldData,
        notes: payload,
      }),
    );
    refetchAllDocumentsQueries();
  };

  return useMutation({
    mutationFn: (notes: string | null) =>
      postDocumentsNotes({
        documentId: documentId!,
        body: notes ? { notes } : {},
      }),
    onSuccess,
  });
};
